import { Component, OnInit, Input, OnDestroy, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { FlightOffer } from '@app/models/offerpack/FlightOffer';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'clever-flight-detail',
    templateUrl: './flight-detail.component.html',
    styleUrls: ['./flight-detail.component.scss'],
    standalone: false
})
export class FlightDetailComponent implements OnInit, OnDestroy {
    @Input() datas: FlightOffer;
    @Output() sendReg: EventEmitter<boolean> = new EventEmitter();
    private unsubscribe$ = new Subject();

    deskMode: boolean = true;

    constructor(
        protected mediaObserver: BreakpointObserver,
        private cdr: ChangeDetectorRef
    ) {}

    ngOnInit(): void {
        this.initMedia();
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }

    async initMedia() {
        if (this.mediaObserver.isMatched(Breakpoints.XSmall)) {
            this.deskMode = false;
        }
        if (this.mediaObserver.isMatched(Breakpoints.Small)) {
            this.deskMode = false;
        }
        if (this.mediaObserver.isMatched(Breakpoints.Medium)) {
            this.deskMode = false;
        }
        if (this.mediaObserver.isMatched(Breakpoints.Large)) {
            this.deskMode = true;
        }
        if (this.mediaObserver.isMatched(Breakpoints.XLarge)) {
            this.deskMode = true;
        }
        this.cdr.detectChanges();
    }

    sendAnmeldung() {
        this.sendReg.emit(true);
    }
}
